var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-checkbox-group',{model:{value:(_vm.checkList),callback:function ($$v) {_vm.checkList=$$v},expression:"checkList"}},_vm._l((_vm.lines),function(temp){return _c('p',{key:'temp' + temp,staticClass:"temp"},[_c('el-checkbox',{attrs:{"label":2 ** (temp - 1)},on:{"change":_vm.tempSetCheck}},[_vm._v(_vm._s(temp)+"路")])],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }